import { apiClient } from '@/lib/api-client';
import type { Project } from '@/types';

export type { Project } from '@/types';

export interface CreateProjectRequest {
  clientId: string;
  name: string;
  type: 'client' | 'side-project';
  notes?: string;
}

export interface UpdateProjectRequest {
  clientId?: string;
  name?: string;
  type?: 'client' | 'side-project';
  notes?: string;
}

export class ProjectsService {
  /**
   * Get all projects (with optional clientId filter)
   */
  async getProjects(clientId?: string): Promise<Project[]> {
    const queryParams = clientId ? `?clientId=${clientId}` : '';
    return await apiClient.get<Project[]>(`/projects${queryParams}`);
  }

  /**
   * Get a specific project by ID
   */
  async getProject(id: string): Promise<Project> {
    return await apiClient.get<Project>(`/projects/${id}`);
  }

  /**
   * Create a new project
   */
  async createProject(data: CreateProjectRequest): Promise<Project> {
    return await apiClient.post<Project>('/projects', data);
  }

  /**
   * Update an existing project
   */
  async updateProject(id: string, data: UpdateProjectRequest): Promise<Project> {
    return await apiClient.put<Project>(`/projects/${id}`, data);
  }

  /**
   * Delete a project
   */
  async deleteProject(id: string): Promise<void> {
    return await apiClient.delete<void>(`/projects/${id}`);
  }
}

export const projectsService = new ProjectsService();
